<div class="mat-elevation-z8">
    <div class="filter-actions-line">
      <mat-form-field appearance="outline">
        <mat-label>Select Disposal Site</mat-label>
        <mat-select [formControl]="selectedSiteIdControl">
          @for (stream of sdcSites(); track stream.id) {
            <mat-option [value]="stream.id">{{ stream.siteName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>  
      <mat-form-field appearance="outline" style="width:250px">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
          <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
          <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
  
      <button id="sdcSearchButton" data-testid="sdcSearchButton" mat-raised-button color="primary"
        (click)="onSearch()">
        <mat-icon>search</mat-icon>Search
      </button>
      <!-- Add Button -->
       @if(controlPermissions.addButton){
        <button mat-raised-button color="primary" (click)="onAddOrEdit(null, 'Add', controlPermissions.addButton)">
          <mat-icon>add</mat-icon>
          Add
        </button>
       }
    </div>
  </div>
  <div class="mat-elevation-z8 mar-top-20">
    <mat-card>
      <mat-card-content>
        <div class="gridheight clear-both viewport">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <ng-container *matCellDef="let row">
                <td mat-cell *ngIf="rowSpanFor.get(row) as span" [attr.rowspan]="span" class="merged-cell" [ngClass]="{'group-odd': isGroupOdd(row), 'group-even': !isGroupOdd(row)}">
                  <div>
                    <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit"
                      (click)="onAddOrEdit(row, 'Edit', controlPermissions.edit)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    @if(controlPermissions.delete){
                      <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row)" style="color: red;">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="dateCaptured">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <ng-container *matCellDef="let element">
                <td mat-cell *ngIf="rowSpanFor.get(element) as span" [attr.rowspan]="span" class="merged-cell" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.dateCaptured | date:'MM/dd/yyyy'}} </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="plant">
              <th mat-header-cell *matHeaderCellDef>Plant</th>
              <ng-container *matCellDef="let element">
                <td mat-cell *ngIf="rowSpanFor.get(element) as span" [attr.rowspan]="span" class="merged-cell" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.plant}} </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="processName">
              <th mat-header-cell *matHeaderCellDef>Process</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.processName}} </td>
            </ng-container>
            <ng-container matColumnDef="equipmentCategory">
              <th mat-header-cell *matHeaderCellDef>Tier 1</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.equipmentCategory}} </td>
            </ng-container>
            <ng-container matColumnDef="equipmentName">
              <th mat-header-cell *matHeaderCellDef>Tier 2</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.equipmentName}} </td>
            </ng-container>
            <ng-container matColumnDef="downtime">
              <th mat-header-cell *matHeaderCellDef>Downtime<br />(min)</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.downtime}} </td>
            </ng-container>
            <ng-container matColumnDef="impactName">
              <th mat-header-cell *matHeaderCellDef>Type of Downtime</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.impactName}} </td>
            </ng-container>
            <ng-container matColumnDef="trigger">
              <th mat-header-cell *matHeaderCellDef>Trigger</th>
              <td mat-cell *matCellDef="let element"
                  [ngClass]="[isGroupOdd(element) ? 'group-odd' : 'group-even', getTriggerColorClass(element.trigger)]">
                {{element.trigger}}
              </td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell *matHeaderCellDef>Comments</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.comments}} </td>
            </ng-container>
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef>Entered By</th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'group-odd': isGroupOdd(element), 'group-even': !isGroupOdd(element)}"> {{element.createdBy}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'group-odd': isGroupOdd(row), 'group-even': !isGroupOdd(row)}"></tr>
  
            <!-- No Data Row -->
            <tr class="mat-row hover:bg-transparent" *matNoDataRow>
              <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length"
                  style="color: red;text-align: center;font-weight: 500;">
                No site downtime data found for this site.
              </td>
            </tr>
          </table>
       </div>
      </mat-card-content>
    </mat-card>
  </div>
